import { OverridesStyleRules } from '@mui/material/styles/overrides'

const MuiInput: OverridesStyleRules = {
    defaultProp: {},
    styleOverrides: {},
    variants: [],
}

export default MuiInput
